import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 100%;
	height: 100%;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: column;
	gap: 3rem;
	overflow: auto;
`;

export const threeItensPorLine = styled.div`
	width: 99%;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	gap: 3rem;
	align-items: center;
	justify-content: center;

	@media (max-width: 1350px) {
		width: 99%;
		grid-template-columns: 1fr 1fr 1fr;
	}

	@media (max-width: 1060px) {
		width: 99%;
		grid-template-columns: 1fr;
	}
`;

export const noInputs = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;

	> p {
		font-size: 1.5rem;
		font-weight: 900;
		color: ${color.interface.lightGray};
	}
`;

export const labelWithOptions = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 1rem;

	> h3 {
		font-weight: 700;
		color: ${color.interface.lightGray};
		font-size: 1.5rem;
		text-transform: capitalize;
	}
`;

export const boxOptions = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 1.5rem;
`;

export const optionToChose = styled.div<{ $isSelect: boolean }>`
	width: 100%;
	position: relative;
	text-align: center;
	padding: 1rem;
	cursor: pointer;
	border: 1px solid
		${(props) =>
			props.$isSelect ? color.system.info : color.interface.lightGray2};
	border-radius: 5px;

	> p {
		color: ${color.interface.lightGray};
		font-size: 1.4rem;
	}
`;

export const checkedItem = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	top: 0;
	right: 0;
	background-color: ${color.system.info};
	border-top-right-radius: 3px;
	border-bottom-left-radius: 5px;
	padding: 2px;

	> svg {
		color: ${color.interface.white};
		font-size: 8px;
	}
`;
